import React from "react";
import { BadgeSoft, CompetitorFavicon, competitorHref } from "@/components/vb";
import type { Buyer } from "@/types/vb";

/** Left column of the detail view (proto .persona-card): name + provenance,
 *  description, competitor chips, and the Edit affordance that opens VB-G. */
export function PersonaCard({ buyer, onEdit }: { buyer: Buyer; onEdit: () => void }) {
  const nameEdited = buyer.edited_fields.includes("name");

  return (
    <div className="vb-dcard vb-dcard--persona">
      <div className="vb-dcard__hd">
        <span className="vb-dcard__lbl">Persona</span>
        <button type="button" className="vb-dcard__edit" onClick={onEdit}>
          Edit
        </button>
      </div>

      <div className="vb-kv">
        <span className="vb-kv__k">
          Name
          {nameEdited && <BadgeSoft tone="edited">Edited</BadgeSoft>}
        </span>
        <span className="vb-kv__v">{buyer.name}</span>
      </div>

      <div className="vb-kv">
        <span className="vb-kv__k">Who they are</span>
        <span className="vb-kv__v vb-kv__v--desc">{buyer.description}</span>
      </div>

      <div className="vb-kv">
        <span className="vb-kv__k">Competitors</span>
        {buyer.competitors.length > 0 ? (
          <div className="vb-persona-chips">
            {buyer.competitors.map((c) => (
              <a
                className="vb-persona-chip"
                key={c.id}
                href={competitorHref(c.url)}
                target="_blank"
                rel="noopener noreferrer"
                title={`Open ${c.name}`}
              >
                <CompetitorFavicon name={c.name} url={c.url} size={14} />
                <span className="vb-persona-chip__name" title={c.name}>{c.name}</span>
              </a>
            ))}
          </div>
        ) : (
          <span className="vb-kv__v vb-kv__v--desc">
            No competitors yet. Add some so AI compares you against them.
          </span>
        )}
      </div>
    </div>
  );
}

export default PersonaCard;
